export function createDeactivationURL(
  deactivationURL: string | undefined,
  appAlias: string
) {
  const url = new URL(
    deactivationURL || `https://dash.elfsight.com/apps/${appAlias}/pricing`
  );
  return setUTM(url, appAlias);
}

function setUTM(url: URL, appAlias: string) {
  const utmParams = {
    utm_source: 'websites',
    utm_medium: 'clients',
    utm_campaign: 'deactivated-widget',
    utm_term: resolveCurrentHostname(),
    utm_content: appAlias
  };

  Object.entries(utmParams).map(([key, value]) => {
    if (value) {
      url.searchParams.set(key, value);
    }
  });

  return url;
}

// @TODO move into lib
function resolveCurrentHostname() {
  try {
    const isIframe = window.location != window.parent.location;
    const url = new URL(isIframe ? document.referrer : document.location.href);
    return url.hostname;
  } catch {
    return undefined;
  }
}
